import Icon from 'components/Icon';
import ListItem from 'components/ListItem';
import Status from 'components/Status';
import Text from 'components/Text';

type Props =
	| (ItemWithClickProps & StatusProps)
	| (ItemWithUrlProps & StatusProps);

type StatusProps =
	| {
			inStock: boolean;
			isOpen?: never;
			openHours?: never;
			stockStatusText: string;
	  }
	| {
			inStock?: never;
			isOpen: boolean;
			openHours: string;
			stockStatusText?: never;
	  };

interface BaseProps {
	address: string;
	className?: string;
	distance?: string;
	isSelected?: boolean;
	name: string;
	storeArea: string;
}

interface ItemWithClickProps extends BaseProps {
	onClick: () => void;
	url?: never;
}

interface ItemWithUrlProps extends BaseProps {
	onClick?: never;
	url: string;
}

export default function StoreListItem({
	address,
	className,
	distance,
	inStock,
	isOpen,
	isSelected,
	name,
	onClick,
	openHours,
	stockStatusText,
	storeArea,
	url,
}: Props) {
	return (
		<ListItem
			as="li"
			isSelected={isSelected}
			href={url}
			onClick={onClick}
			title={name}
			className={className}
			endContent={url && <Icon name="chevron-right" className="self-center" />}
		>
			<Text as="p" text={storeArea} />
			<Text as="p" text={address} className="mb-2" />
			{distance && <Text as="p" text={distance} className="mb-2" />}
			<Status
				variant={(inStock ?? isOpen) ? 'positive' : 'negative'}
				text={stockStatusText ?? openHours}
			/>
		</ListItem>
	);
}
StoreListItem.displayName = 'StoreListItem';
